<template>
  <button @click="onClick()">
    <div class="text-container">{{ title }}</div>
  </button>
</template>

<script>
export default {
  props: {
    onClick: Function,
    title: String,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';

button {
  background-color: $purple;
  border: none;
  border-radius: 2px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);
  color: $white;
  margin: 0.6rem;
  outline: none;
  padding: 1rem;
  text-transform: uppercase;
  white-space: nowrap;
  width: 100%;
  align-content: center;

  &:hover {
    background-color: $light-purple;
  }

  &:active {
    background-color: $dark-purple;
  }

  & .text-container {
    font-family: Roboto;
    font-size: 11.2px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    text-align: center;
  }
}
</style>
